// ===== Enums =====

export enum FeeType {
  LATE_FEE = 'LATE_FEE',
  LATE_INTEREST = 'LATE_INTEREST',
  NSF_FEE = 'NSF_FEE',
  ATTORNEY_FEE = 'ATTORNEY_FEE',
  LIEN_FEE = 'LIEN_FEE',
  CUSTOM = 'CUSTOM'
}

export enum AllowanceType {
  ONLINE_COLLECTION = 'ONLINE_COLLECTION',
  EARLY_PAYMENT = 'EARLY_PAYMENT',
  CREDIT = 'CREDIT',
  CUSTOM = 'CUSTOM'
}

export enum ReturnStatus {
  PENDING = 'PENDING',
  UNPAID = 'UNPAID',
  PAID = 'PAID',
  PARTIALLY_PAID = 'PARTIALLY_PAID',
  OVERDUE = 'OVERDUE',
  CANCELLED = 'CANCELLED',
  VOID = 'VOID',
  ZERO_RETURN = 'ZERO_RETURN'
}

export enum ReturnType {
  STANDARD = 'STANDARD',
  REGULAR = 'REGULAR',
  AMENDED = 'AMENDED',
  ESTIMATED = 'ESTIMATED',
  ZERO = 'ZERO',
  /** Materialized plan returns (one row per scheduled payment / lump sum). */
  INSTALLMENT = 'INSTALLMENT',
  ASSESSMENT = 'ASSESSMENT',
  LIEN = 'LIEN'
}

export enum PaymentStatus {
  PENDING = 'PENDING',
  COMPLETED = 'COMPLETED',
  FAILED = 'FAILED',
  VOID = 'VOID'
}

// ===== Fee DTOs =====

export interface FeeDto {
  id: number;
  type: FeeType;
  customName?: string;
  amount: number;
  enabled: boolean;
  createdAt: string;
  createdBy: string;
}

export interface CreateFeeRequestDto {
  type: FeeType;
  customName?: string;
  amount: number;
}

// ===== Allowance DTOs =====

export interface AllowanceDto {
  id: number;
  type: AllowanceType;
  customName?: string;
  amount: number;
  enabled: boolean;
  createdAt: string;
  createdBy: string;
}

export interface CreateAllowanceRequestDto {
  type: AllowanceType;
  customName?: string;
  amount: number;
}

// ===== Note DTOs =====

export interface ReturnNoteDto {
  id: number;
  content: string;
  createdAt: string;
  createdBy: string;
}

export interface CreateNoteRequestDto {
  content: string;
}

// ===== Attachment DTOs =====

export interface ReturnAttachmentDto {
  id: number;
  fileName: string;
  fileSize: number;
  contentType: string;
  storageKey: string;
  uploadedAt: string;
  uploadedBy: string;
}

// ===== History DTOs =====

export interface ReturnHistoryDto {
  id: number;
  returnId: number;
  action: string;
  fieldName?: string;
  oldValue?: string;
  newValue?: string;
  description: string;
  userId: string;
  userName: string;
  timestamp: string;
}

// ===== Return Property DTOs =====

export interface ReturnPropertyDto {
  id: number;
  propertyId: number;
  propertyAddress: string;
  grossRentalReceipts: number;
  exemptions: number;
  taxableRentalReceipts: number;
  taxAmount: number;
}

export interface ReturnPropertyUpdateDto {
  propertyId: number;
  grossRentalReceipts: number;
  exemptions: number;
}

// ===== Search Criteria =====

export interface ReturnSearchCriteria {
  accountId?: number;
  customerId?: string;
  status?: ReturnStatus;
  type?: ReturnType;
  periodStart?: string;
  periodEnd?: string;
  dueDateStart?: string;
  dueDateEnd?: string;
}
